// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3330": "1852a85d","8357": "dd422574","8795": "631c6af3","993": "61780bf8",}[chunkId] + ".css"
}